import { useAppContext } from 'Providers/AppProvider/AppContext';

/** Minimal shape we read — accepts both `QuoteV2` and the legacy `QuoteDTO`. */
type QuoteWithOwner = { user?: { email?: string | null } | null } | null;

/**
 * "Prepared By" is the quote owner's own sales-rep details. Only the creator
 * may edit it; a non-creator (e.g. a rep the quote was shared with) must not
 * overwrite it with their own profile. The owner is matched to the logged-in
 * user by email; when the owner email is unknown we default to allowing edits.
 *
 * Used by both the Quotes Settings modal (to hide the step) and the PDF preview
 * tab (to make the Prepared By section non-clickable for non-creators).
 */
export const useCanEditPreparedBy = (quote?: QuoteWithOwner): boolean => {
  const { user } = useAppContext();
  const ownerEmail = quote?.user?.email || undefined;
  return (
    !ownerEmail ||
    ownerEmail.toLowerCase() === (user?.Email || '').toLowerCase()
  );
};
